import React, { useRef, useState } from "react";
import Bar from "./icons/Bar";
import BoxPlot from "./icons/BoxPlot";
import Histogram from "./icons/Histogram";
import Pie from "./icons/Pie";
import Scatter from "./icons/Scatter";
import Stats from "./icons/Stats";
import LineChart from "./icons/LineChart";
import MultiScatter from "./icons/MultiScatter";

import "./style.css";
import IconButton from "./IconButton";
import { ChartType } from "./types";
import Table from "./icons/Table";

const ChartTypeMenu = ({ loaded, selectChartType }: { loaded: boolean; selectChartType: any }) => {
  const iconStyle = "chartIcons";
  const [displaySettings, setDisplaySettings] = useState<boolean>(false);
  const iconSize = 30;
  const refLine = useRef<any>();
  const refBar = useRef<any>();
  const refBox = useRef<any>();
  const refHistogram = useRef<any>();
  const refPlotPie = useRef<any>();
  const refScatter = useRef<any>();
  const refMultiScatter = useRef<any>();
  const refStats = useRef<any>();
  const refRaw = useRef<any>();

  const changeSelectedIconOnly = (refName: any) => {
    refName.className = "selectedChartIcon";

    if (refName !== refBar.current) {
      refBar.current.className = iconStyle;
    }
    if (refName !== refBox.current) {
      refBox.current.className = iconStyle;
    }
    if (refName !== refHistogram.current) {
      refHistogram.current.className = iconStyle;
    }
    if (refName !== refPlotPie.current) {
      refPlotPie.current.className = iconStyle;
    }
    if (refName !== refScatter.current) {
      refScatter.current.className = iconStyle;
    }
    if (refName !== refMultiScatter.current) {
      refMultiScatter.current.className = iconStyle;
    }
    if (refName !== refStats.current) {
      refStats.current.className = iconStyle;
    }
    if (refName !== refLine.current) {
      refLine.current.className = iconStyle;
    }
    if (refName !== refRaw.current) {
      refRaw.current.className = iconStyle;
    }
  };

  const onClick = (e: any, index: number) => {
    let chartType: ChartType;
    switch (e.currentTarget.id) {
      case "barChart": {
        chartType = "BAR";
        changeSelectedIconOnly(refBar.current);
        setDisplaySettings(true);
        break;
      }
      case "boxChart": {
        chartType = "BOX";
        changeSelectedIconOnly(refBox.current);
        break;
      }
      case "histogramChart": {
        chartType = "HISTOGRAM";
        changeSelectedIconOnly(refHistogram.current);
        break;
      }
      case "plotPieChart": {
        chartType = "PIE";
        changeSelectedIconOnly(refPlotPie.current);
        break;
      }
      case "scatterChart": {
        chartType = "SCATTER";
        changeSelectedIconOnly(refScatter.current);
        break;
      }
      case "multiScatterChart": {
        chartType = "MULTISCATTER";
        changeSelectedIconOnly(refMultiScatter.current);
        break;
      }
      case "statsChart": {
        chartType = "STATS";
        changeSelectedIconOnly(refStats.current);
        break;
      }
      case "lineChart": {
        chartType = "LINE";
        changeSelectedIconOnly(refLine.current);
        break;
      }
      case "rawChart": {
        chartType = "RAW";
        changeSelectedIconOnly(refRaw.current);
        break;
      }
      default:
        chartType = "LINE";
        refLine.current.className = "selectedChartIcon";
        break;
    }
    selectChartType(chartType);
  };

  return (
    <div className="dynamicCol">
      <IconButton onClick={onClick} id="line" className={iconStyle && (loaded ? `selectedChartIcon` : ``)} ref={refLine} dataTooltip="Line chart">
        <LineChart width={iconSize} height={iconSize} id="lineIcon" />
      </IconButton>
      <IconButton onClick={onClick} id="bar" className={iconStyle} ref={refBar} dataTooltip="Bar chart">
        <Bar width={iconSize} height={iconSize} id="barIcon" />
      </IconButton>
      <IconButton onClick={onClick} id="box" className={iconStyle} ref={refBox} dataTooltip="Box plot">
        <BoxPlot width={iconSize} height={iconSize} id="boxIcon" />
      </IconButton>
      <IconButton onClick={onClick} id="histogram" className={iconStyle} ref={refHistogram} dataTooltip="Histogram">
        <Histogram width={iconSize} height={iconSize} id="histogramIcon" />
      </IconButton>
      <IconButton onClick={onClick} id="plotPie" className={iconStyle} ref={refPlotPie} dataTooltip="Pie plot">
        <Pie width={iconSize} height={iconSize} id="plotPieIcon" />
      </IconButton>
      <IconButton onClick={onClick} id="scatter" className={iconStyle} ref={refScatter} dataTooltip="Scatter chart">
        <Scatter width={iconSize} height={iconSize} id="scatterIcon" />
      </IconButton>
      <IconButton onClick={onClick} id="multiScatter" className={iconStyle} ref={refMultiScatter} dataTooltip="Multi scatter chart">
        <MultiScatter width={iconSize} height={iconSize} id="multiScatterIcon" />
      </IconButton>
      <IconButton onClick={onClick} id="stats" className={iconStyle} ref={refStats} dataTooltip="Statistics">
        <Stats width={iconSize} height={iconSize} id="stats" />
      </IconButton>
      <IconButton onClick={onClick} id="raw" className={iconStyle} ref={refRaw} dataTooltip="Raw Data Table">
        <Table width={iconSize} height={iconSize} id="raw" />
      </IconButton>
    </div>
  );
};

export default ChartTypeMenu;
